import moment from "moment";
// Regular Expression Patterns
var alphaRegex = /^[a-zA-Z]+$/;
var alphaUnstrictRegex = /^[a-zA-Z\s|(|)]*$/;
var numericRegex = /^\d+$/;
var forbiddenCharsRegex = /`|~|%|\*|\+|=|\[|\{|\]|\}|\||<|>/;
var nameRegex = /^[a-zA-Z \-']+(?:\s[a-zA-Z]+)*$/;
var completePhoneRegex = /^\(?\d{3}\)?[- ]?\d{3}[- ]?\d{4}$/;
var incompletePhoneRegex = /^[0-9-]*$/;
var emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
var dateRegex = /(\d+)(-|\/)(\d+)(?:-|\/)(?:(\d+)\s+(\d+):(\d+)(?::(\d+))?(?:\.(\d+))?)?/;
var zipcodeRegex = /(^\d{5}$)|(^\d{5}-\d{4}$)/;

// Validate field has input
function isBlank(input) {
  return !input;
}

export const fieldValidations = {
  isAlpha: (input, isRequired) => {
    var errorMessage = "Alphabetic characters only";
    return patternValidation(alphaRegex, input, isRequired, errorMessage);
  },
  isAlphaUnstrict: (input, isRequired) => {
    var errorMessage = "Alphabetic characters only";
    return patternValidation(
      alphaUnstrictRegex,
      input,
      isRequired,
      errorMessage
    );
  },
  isNumeric: (input, isRequired) => {
    var errorMessage = "Numbers only";
    return patternValidation(numericRegex, input, isRequired, errorMessage);
  },
  isTrue: (input, isRequired) => {
    var errorMessage = "This field is required";
    return input ? false : errorMessage;
  },
  hasForbiddenChars: (input, isRequired) => {
    var errorMessage = "No special characters";
    input = input.trim();
    if (isRequired && isBlank(input)) {
      errorMessage = "This field is required";
      return errorMessage;
    }
    if (!input.match(forbiddenCharsRegex)) {
      return false;
    }
    return errorMessage;
  },
  validateRadio: (input, isRequired) => {
    const errorMessage = "Please select an option";
    if (isBlank(input)) {
      return errorMessage;
    }
    return false;
  },
  nameValidate: (input, isRequired) => {
    const errorMessage = "Must be a valid name.";
    return patternValidation(nameRegex, input, isRequired, errorMessage);
  },
  isCompletePhone: (input, isRequired) => {
    var errorMessage = "Must be a valid phone number";
    return patternValidation(
      completePhoneRegex,
      input,
      isRequired,
      errorMessage
    );
  },
  isIncompletePhone: (input, isRequired) => {
    var errorMessage = "Numeric characters only";
    return patternValidation(
      incompletePhoneRegex,
      input,
      isRequired,
      errorMessage
    );
  },
  isValidEmail: (input, isRequired) => {
    var errorMessage =
      "A valid email address is required. We communicate application status updates through email.";
    return patternValidation(emailRegex, input, isRequired, errorMessage);
  },
  isValidDate: (input, isRequired) => {
    var date = moment(input);
    if (date.isValid()) {
      input = moment(input).format("L");
    }
    var errorMessage = "Please use date format dd/mm/yyyy";
    return patternValidation(dateRegex, input, isRequired, errorMessage);
  },
  isValidInches: (input, isRequired) => {
    var errorMessage = "Must be a valid number between 0-11";
    if (
      patternValidation(numericRegex, input, isRequired, errorMessage) ||
      !(input <= 11)
    ) {
      return errorMessage;
    }
    return false;
  },
  isValidFeet: (input, isRequired) => {
    var errorMessage = "Must be a valid number between 2-10";
    if (
      patternValidation(numericRegex, input, isRequired, errorMessage) ||
      !(input <= 10) ||
      !(input >= 2)
    ) {
      return errorMessage;
    }
    return false;
  },
  legalAge: (input, isRequired) => {
    var formattedInput = moment(input).format("L");
    var errorMessage = !moment(input).isSameOrAfter("1900-01-01")
      ? "Must be a valid date later than 01/01/1900."
      : "Primary applicant must be at least 18 years of age.";
    var pValidation = patternValidation(
      dateRegex,
      formattedInput,
      isRequired,
      errorMessage
    );
    if (
      pValidation == false &&
      moment().diff(input, "years") >= 18 &&
      moment(input).isSameOrAfter("1900-01-01")
    ) {
      return false;
    } else {
      return errorMessage;
    }
  },
  isMinor: (input, isRequired) => {
    var cutOff = moment().subtract(18, "years");
    var formattedInput = moment(input).format("L");
    var errorMessage = moment(input).isValid()
      ? "Minor applicant must be below 18 years of age."
      : "Please enter a valid date of birth.";
    var pValidation = patternValidation(
      dateRegex,
      formattedInput,
      isRequired,
      errorMessage
    );
    if (moment(input).isValid() && moment(input).isSameOrAfter(cutOff)) {
      return false;
    } else {
      return errorMessage;
    }
  },
  isValidZipcode: (input, isRequired) => {
    var errorMessage = "Must be a valid zipcode.";
    return patternValidation(zipcodeRegex, input, isRequired, errorMessage);
  },
  isLastFourSsn: (input, isRequired) => {
    var errorMessage = "Must be a four digit number greater than 0";
    if (!self.isNumeric(input) && input.length === 4 && input > 0) {
      return false;
    } else {
      return errorMessage;
    }
  }
};

const self = fieldValidations;

// Validation Logic
function patternValidation(regex, input, isRequired, errorMessage) {
  input = input.trim();
  if (isRequired && isBlank(input)) {
    errorMessage = "This field is required";
    return errorMessage;
  }
  if (input.match(regex) || (!isRequired && isBlank(input))) {
    return false;
  }
  return errorMessage;
}



// WEBPACK FOOTER //
// ./src/utils/fieldValidations.js